import { AxiosApi } from "api"
import { ApiResponse } from "interface/response"
import { LandingNoteJournalItem } from "./landingNoteJournalItem"
import { useInfoStore } from "store/error"

export interface LandingNoteJournalFilter{
    noteNumber?:  number,
    source? : number, 
    specie?: string
    specieName?: string
    receiverReceivingFacility?: string
    receiverReceiving?: string
    fishingGearCode?: string
    fishingGear?: string
    fishingGearId?: string
    catchField1?: string
    catchField2?: string
    catchField1Name?: string
      catchField2Name?: string
    conditionCode?: string
    conditionName?: string
    preservationCode?: string
    preservationName?: string
    fishermanLedgerAccount?: string
    fromDate?: Date,
    toDate?: Date,

    vesselId? : string
    vesselName?: string
}

export  async function getLandingNoteJournalApi(params : LandingNoteJournalFilter ) {
    const apiUri = "LandingNote/JournalItem"
   try {
      const registrations = await AxiosApi.get<ApiResponse<LandingNoteJournalItem[]>>(apiUri, {params:{
         ...params,
      }})
      return registrations.data.data
   } catch (error: any) {
      const { setError } = useInfoStore.getState();
      setError(error);
      throw  error
   }
}

export  async function getLandingNoteJournalListApi(params : LandingNoteJournalFilter ) {
    const apiUri = "LandingNote/JournalList"

   try {
      const registrations = await AxiosApi.get<ApiResponse<LandingNoteJournalItem[]>>(apiUri, {params:{
         ...params,
      }})
      return registrations.data.data
   } catch (error: any) {
      const { setError } = useInfoStore.getState();
      setError(error);
      throw  error
   }
}